"use client";
import { Button, Card, Form, Input, Checkbox, Typography } from "antd";
import "./style.css";
import Link from "antd/lib/typography/Link";
import logo from "~/assets/logo/logo-no-bg.png";
import { useEffect, useMemo, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLightbulb } from "@fortawesome/free-solid-svg-icons";
const { Title, Text } = Typography;

export const RegisterView = () => {
  const [form] = Form.useForm();
  const [prefixUsername, setPrefixUsername] = useState("");
  const handleRegister = (values: any) => {
    const body = {
      username: values.username,
      password: values.password,
      fullName: values.companyName,
      rootUsername: values.username,
      rootPassword: values.password,
      name: values.companyName,
      rootFullName: values.companyName,
      address: values.address,
      website: values.website,
      domain: prefixUsername,
      tax: values.taxCode,
      phone: values.phone,
      email: values.email,
      shortName: values.shortName,
    };
    try {
      // registerSupplier(body);
    } catch (error) {
      console.log(error);
    }
  };

  const companyName = Form.useWatch("companyName", form);

  // useEffect(() => {
  //   const shortName = form.getFieldValue("shortName");
  //   if (shortName && shortName !== undefined) {
  //     setPrefixUsername(`${prefix}${shortName}`);
  //   } else {
  //     setPrefixUsername(`${prefix}`);
  //   }
  // }, [companyName]);
  const prefix = useMemo(() => {
    if (!companyName) return "";
    return companyName
      .split(" ")
      .map((w) => w[0])
      .join("")
      .toLowerCase();
  }, [companyName]);

  return (
    <div className="register-container">
      <Card className="register-card">
        <div className="register-header">
          <Link href="/">
            <img src={logo} alt="Logo" width={64} height={64} />
          </Link>
          <Title level={3}>Tạo tài khoản Doanh nghiệp</Title>
          <Text type="secondary">
            Tham gia nền tảng B2B hàng đầu để kết nối và phát triển.
          </Text>
        </div>

        <Form layout="vertical" onFinish={handleRegister} form={form}>
          {/* THÔNG TIN CÔNG TY */}
          <div className="section">
            <Title level={5}>Thông tin công ty</Title>
            <div className="form-grid">
              <Form.Item
                name="companyName"
                label="Tên công ty"
                rules={[
                  { required: true, message: "Vui lòng nhập tên công ty" },
                ]}
              >
                <Input placeholder="Tên công ty của bạn" />
              </Form.Item>
              <div>
                <Form.Item
                  name="shortName"
                  label="Tên viết tắt"
                  rules={[
                    { required: true, message: "Vui lòng nhập tên viết tắt" },
                  ]}
                >
                  <Input
                    style={{ width: "100%" }}
                    placeholder="VD: Công Ty A -&gt; cta"
                    onChange={(e) => setPrefixUsername(`${e.target.value}`)}
                    allowClear
                  />
                </Form.Item>
                <Text type="secondary">
                  <FontAwesomeIcon
                    icon={faLightbulb}
                    style={{ marginRight: 4 }}
                  />
                  Gợi ý: {prefix}
                </Text>
              </div>
            </div>
            <div className="form-gird">
              <Form.Item
                name="taxCode"
                label="Mã số thuế / GPKD"
                rules={[
                  { required: true, message: "Vui lòng nhập mã số thuế" },
                ]}
              >
                <Input placeholder="Mã số thuế hoặc giấy phép kinh doanh" />
              </Form.Item>
              <Form.Item
                name="address"
                label="Địa chỉ công ty"
                rules={[
                  { required: true, message: "Vui lòng nhập địa chỉ công ty" },
                ]}
              >
                <Input placeholder="Số nhà, đường, phường/xã, quận/huyện, tỉnh/thành phố" />
              </Form.Item>
            </div>
          </div>

          {/* THÔNG TIN TÀI KHOẢN */}
          <div className="section">
            <Title level={5}>Thông tin tài khoản</Title>
            <Form.Item
              name="email"
              label="Email"
              rules={[
                {
                  required: true,
                  type: "email",
                  message: "Vui lòng nhập email",
                },
              ]}
            >
              <Input placeholder="email@congty.com" />
            </Form.Item>
            <div className="form-grid">
              <Form.Item
                name="username"
                label="Tài khoản"
                rules={[{ required: true, message: "Vui lòng nhập tài khoản" }]}
              >
                <Input
                  placeholder="Tài khoản đăng nhập"
                  suffix={`@${prefixUsername}`}
                />
              </Form.Item>
            </div>
            <div className="form-grid">
              <Form.Item
                name="password"
                label="Mật khẩu"
                rules={[{ required: true, message: "Vui lòng nhập mật khẩu" }]}
              >
                <Input.Password />
              </Form.Item>

              <Form.Item
                name="confirmPassword"
                label="Xác nhận mật khẩu"
                rules={[
                  { required: true, message: "Vui lòng xác nhận mật khẩu" },
                ]}
              >
                <Input.Password />
              </Form.Item>
            </div>
          </div>

          <Form.Item
            name="agree"
            valuePropName="checked"
            rules={[
              {
                validator: (_, value) =>
                  value
                    ? Promise.resolve()
                    : Promise.reject("Bạn cần đồng ý với điều khoản."),
              },
            ]}
          >
            <Checkbox>
              Tôi đồng ý với các{" "}
              <Link href="/terms-register" className="terms-link">
                điều khoản và điều kiện
              </Link>
              .
            </Checkbox>
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ width: "100%" }}>
              Đăng ký
            </Button>
          </Form.Item>
        </Form>

        <div className="register-footer">
          Đã có tài khoản? <Link href="/login">Đăng nhập</Link>
        </div>
      </Card>
    </div>
  );
};
